<div [ngClass]="{'publishing': publishing}" #publisherDiv></div>
